var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _path6, _g4, _path7, _path8, _path9, _path0, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPetProtectCopayActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4249 21.8563C43.4249 23.2393 43.2964 24.5931 43.0462 25.9041C42.945 26.4403 42.8234 26.9674 42.6837 27.4879C41.794 30.7989 40.1385 33.7929 37.9174 36.2727C37.8406 36.3561 37.7663 36.4419 37.6875 36.5229C33.7387 40.8027 28.0825 43.4812 21.8 43.4812C11.5621 43.4812 2.98645 36.3675 0.747293 26.8118C0.373513 25.2217 0.175293 23.5616 0.175293 21.8563C0.175293 20.6287 0.276493 19.4234 0.476913 18.2521C2.19115 8.02318 11.0844 0.231445 21.8 0.231445C33.7431 0.231445 43.4249 9.9132 43.4249 21.8563Z",
    fill: "#95E6E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_375_17703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.477133 18.2521C0.276493 19.4234 0.175293 20.6285 0.175293 21.8561C0.175293 23.5613 0.373513 25.2217 0.747513 26.8118C2.98667 36.3675 11.5623 43.4812 21.8002 43.4812C28.0825 43.4812 33.7387 40.8027 37.6877 36.5226C37.7665 36.4417 37.8408 36.3559 37.9176 36.2727C40.1385 33.7927 41.7942 30.7989 42.6839 27.4877C42.8234 26.9674 42.9453 26.44 43.0465 25.9041C43.2966 24.5931 43.4249 23.2393 43.4249 21.8561C43.4249 9.91298 33.7433 0.231445 21.8002 0.231445C11.0847 0.231445 2.19137 8.02318 0.477133 18.2521Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_375_17703)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9403 7.64664H14.2521C13.3028 7.64664 12.3604 6.96222 12.3604 6.32928V6.09894C12.3604 5.46599 13.3028 4.89487 14.2521 4.89487H16.6598C17.6093 4.89487 18.3798 4.49425 18.3798 3.86131C18.3798 3.22837 19.1502 2.83105 20.0995 2.83105H35.0965C37.2289 4.20693 39.1896 5.58282 40.9403 7.64664Z",
    fill: "#D3F2F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_375_17703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.477133 18.2521C0.276493 19.4234 0.175293 20.6285 0.175293 21.8561C0.175293 23.5613 0.373513 25.2217 0.747513 26.8118C2.98667 36.3675 11.5623 43.4812 21.8002 43.4812C28.0825 43.4812 33.7387 40.8027 37.6877 36.5226C37.7665 36.4417 37.8408 36.3559 37.9176 36.2727C40.1385 33.7927 41.7942 30.7989 42.6839 27.4877C42.8234 26.9674 42.9453 26.44 43.0465 25.9041C43.2966 24.5931 43.4249 23.2393 43.4249 21.8561C43.4249 9.91298 33.7433 0.231445 21.8002 0.231445C11.0847 0.231445 2.19137 8.02318 0.477133 18.2521Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_375_17703)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7404 26.2392V26.5318C10.7404 27.339 10.0852 27.9944 9.27781 27.9944H-7.04443C-7.03277 27.9095 -7.01803 27.8276 -7.00329 27.7427C-6.66119 25.6952 -6.09667 23.7235 -5.33327 21.8516H2.84259C3.64977 21.8516 4.30515 22.5067 4.30515 23.3141C4.30515 24.1215 4.96031 24.7767 5.7677 24.7767H9.27781C10.0852 24.7767 10.7404 25.4318 10.7404 26.2392Z",
    fill: "#D3F2F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_375_17703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.477133 18.2521C0.276493 19.4234 0.175293 20.6285 0.175293 21.8561C0.175293 23.5613 0.373513 25.2217 0.747513 26.8118C2.98667 36.3675 11.5623 43.4812 21.8002 43.4812C28.0825 43.4812 33.7387 40.8027 37.6877 36.5226C37.7665 36.4417 37.8408 36.3559 37.9176 36.2727C40.1385 33.7927 41.7942 30.7989 42.6839 27.4877C42.8234 26.9674 42.9453 26.44 43.0465 25.9041C43.2966 24.5931 43.4249 23.2393 43.4249 21.8561C43.4249 9.91298 33.7433 0.231445 21.8002 0.231445C11.0847 0.231445 2.19137 8.02318 0.477133 18.2521Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_375_17703)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3355 20.9596H35.6688C35.299 20.9596 34.9628 20.8085 34.7219 20.5676C34.481 20.3264 34.3301 19.9907 34.3301 19.6205C34.3301 18.8806 34.9289 18.2815 35.6688 18.2815H38.8337C39.0676 18.2815 39.2816 18.1867 39.4352 18.0307C39.5909 17.8774 39.6858 17.6633 39.6858 17.4295C39.6858 16.9598 39.3036 16.5776 38.8337 16.5776H37.6164C36.8766 16.5776 36.2775 15.9786 36.2775 15.2385V14.9952C36.2775 14.2551 36.8766 13.6562 37.6164 13.6562H42.0666C43.2011 15.9055 43.9826 18.3645 44.3355 20.9596Z",
    fill: "#D3F2F1"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.52 37.8276L17.4426 34.5218V29.5716C17.4426 27.2315 21.6932 25.3346 21.6932 25.3346C24.0408 25.3346 25.9436 27.2315 25.9436 29.5716V37.8095H35.1317L35.4958 23.8582L21.6932 12.3916L8.56055 23.7355L8.60609 37.8991L15.2844 37.8095L17.52 37.8276Z",
    fill: "#D3F2F1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_375_17703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 44H44V0H0V44Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_375_17703)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41113 42.5558H39.2941V38.2432H4.41113V42.5558Z",
    fill: "#D3F2F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4473 20.8857V37.9049H8.2124L8.36816 23.6993L11.4473 20.8857Z",
    fill: "#E6F972"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4287 42.4807H39.2024V38.4287H11.4287V42.4807Z",
    fill: "#F0F4BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.797 12.2159C21.8753 12.1501 21.9865 12.1447 22.0702 12.1995L22.0923 12.216L35.5189 23.5088C35.5634 23.5462 35.5917 23.5988 35.5989 23.6557L35.6007 23.6845V38.0949C35.6007 38.2133 35.5112 38.3107 35.3962 38.3232L35.3712 38.3245H26.1831C26.0648 38.3245 25.9673 38.235 25.9549 38.12L25.9535 38.0949V29.857C25.9535 27.644 24.1536 25.8499 21.9327 25.8499C19.7364 25.8499 17.9517 27.6044 17.9123 29.7834L17.9116 29.857V35.849C17.9116 35.9758 17.8089 36.0785 17.6821 36.0785C17.5637 36.0785 17.4663 35.989 17.4539 35.874L17.4525 35.849V29.857C17.4525 27.3902 19.4585 25.3907 21.9327 25.3907C24.3814 25.3907 26.3713 27.3491 26.412 29.7809L26.4127 29.857V37.8652H35.1416V23.7914L21.9445 12.6915L8.72379 23.7914V37.8652L15.5239 37.8654C15.6422 37.8654 15.7396 37.9549 15.7521 38.0699L15.7534 38.0949C15.7534 38.2133 15.6639 38.3107 15.5489 38.3232L15.5239 38.3245H8.49422C8.37588 38.3245 8.27846 38.235 8.266 38.12L8.26465 38.0949V23.6845C8.26465 23.6264 8.28669 23.5708 8.3257 23.5286L8.3466 23.5087L21.797 12.2159Z",
    fill: "#293742"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24902 42.5983H11.4696V38.5039H4.24902V42.5983Z",
    fill: "#E6F972"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49129 38.0137H39.3743C39.5011 38.0137 39.6038 38.1165 39.6038 38.2432V42.5559C39.6038 42.6827 39.5011 42.7855 39.3743 42.7855H4.49129C4.3645 42.7855 4.26172 42.6827 4.26172 42.5559V38.2432C4.26172 38.1165 4.3645 38.0137 4.49129 38.0137ZM39.1449 42.3262V38.4727H4.72106V42.3262H39.1449Z",
    fill: "#293742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6206 12.3227C21.1571 11.8771 21.9533 11.9507 22.3989 12.4872C22.8328 13.0096 22.7744 13.7782 22.2758 14.2296L22.2344 14.2655L8.70788 25.5007C8.17138 25.9463 7.37522 25.8726 6.92961 25.3361C6.49572 24.8137 6.55414 24.0452 7.05276 23.5937L7.09416 23.5578L20.6206 12.3227Z",
    fill: "#4E5657",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4244 21.6548L21.8534 7.61328L4.78516 21.6282L7.17414 24.601L21.8534 12.3912L36.7701 24.6276L39.4244 21.6548Z",
    fill: "#E6F972"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46703 21.5576L21.5351 7.43648C21.619 7.36701 21.7403 7.36615 21.8252 7.43441L39.3964 21.5556C39.4959 21.6356 39.5111 21.7814 39.4301 21.8801L36.8818 24.9856C36.8011 25.084 36.6558 25.098 36.5578 25.0168L21.6828 12.6908L7.15083 25.0151C7.058 25.0938 6.92156 25.0857 6.83855 25.0009L6.82039 24.98L4.43141 21.8745C4.35603 21.7765 4.37178 21.6364 4.46703 21.5576ZM38.928 21.7679L21.6833 7.90925L4.93028 21.7699L7.03744 24.5091L21.533 12.2162C21.6108 12.1502 21.7218 12.1441 21.8058 12.1983L21.828 12.2145L36.6732 24.5159L38.928 21.7679Z",
    fill: "#293742"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6273 38.1647L20.3729 35.3066H11.6743L12.4199 38.1647H19.6273Z",
    fill: "#D3F2F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.674 35.0771H20.3726C20.5229 35.0771 20.6327 35.2192 20.5947 35.3647L19.8492 38.2227C19.8228 38.3238 19.7315 38.3943 19.627 38.3943H12.4196C12.3151 38.3943 12.2238 38.3238 12.1975 38.2227L11.4519 35.3647C11.4139 35.2192 11.5237 35.0771 11.674 35.0771ZM19.4495 37.9352L20.0754 35.5363H11.971L12.5969 37.9352H19.4495Z",
    fill: "#293742"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8447 35.3916L12.5903 38.2496H14.1281L13.3825 35.3916H11.8447Z",
    fill: "#4E5657",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_375_17703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 44H44V0H0V44Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_375_17703)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19824 42.7705H40.5835V42.3809H3.19824V42.7705Z",
    fill: "#3A3C3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19824 43.5493H40.5835V42.7705H3.19824V43.5493Z",
    fill: "#E6F972"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.373 11.6179C9.30361 11.9134 9.06403 12.1527 8.76879 13.2222C8.47333 12.1527 8.23397 11.9134 7.16455 11.6179C8.23397 11.3225 8.47333 11.0831 8.76879 10.0137C9.06403 11.0831 9.30361 11.3225 10.373 11.6179Z",
    fill: "#D3F2F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2653 8.62594C36.1959 8.92118 35.9563 9.16076 35.6611 10.2302C35.3656 9.16076 35.1261 8.92118 34.0566 8.62594C35.1261 8.33048 35.3656 8.09112 35.6611 7.02148C35.9563 8.09112 36.1959 8.33048 37.2653 8.62594Z",
    fill: "#D3F2F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1403 26.2392V26.5318C59.1403 27.339 58.4849 27.9944 57.6777 27.9944H41.3555C41.3671 27.9095 41.3816 27.8276 41.3964 27.7427C41.7385 25.6952 42.3032 23.7235 43.0666 21.8516H51.2425C52.0497 21.8516 52.7048 22.5067 52.7048 23.3141C52.7048 24.1215 53.3602 24.7767 54.1674 24.7767H57.6777C58.4849 24.7767 59.1403 25.4318 59.1403 26.2392Z",
    fill: "#D3F2F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2495 30.2343C38.1801 30.5296 37.9407 30.7692 37.6453 31.8386C37.35 30.7692 37.1104 30.5296 36.041 30.2343C37.1104 29.9389 37.35 29.6993 37.6453 28.6299C37.9407 29.6993 38.1801 29.9389 39.2495 30.2343Z",
    fill: "#D3F2F1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetProtectCopayActive);
export default __webpack_public_path__ + "static/media/pet-protect-copay-active.08f2699f60808ab9453ae7f56ee4de81.svg";
export { ForwardRef as ReactComponent };